import { useCallback, useState } from "react";
import { addHiddenKey, readHiddenKeys } from "./hiddenStore.js";

export const REPORT_THANKS = "Thanks — we'll review this within 24 hours.";

/**
 * What a list that shows other people's words needs to offer Report: the keys this reader has
 * already reported (and so no longer sees), and the thanks line to show once one more is.
 * The notice lives here, in the list's host, because the reported row unmounts on success.
 */
export function useReporting(eventId: string | null | undefined) {
  const [hidden, setHidden] = useState<ReadonlySet<string>>(() =>
    eventId ? readHiddenKeys(eventId) : new Set(),
  );
  const [thanks, setThanks] = useState(false);

  const onReported = useCallback(
    (key: string) => {
      if (!eventId) return;
      setHidden(addHiddenKey(eventId, key));
      setThanks(true);
    },
    [eventId],
  );

  const isShown = useCallback((key: string) => !hidden.has(key), [hidden]);
  return { eventId: eventId ?? null, isShown, onReported, thanks };
}

export type Reporting = ReturnType<typeof useReporting>;
